import Swiper, { Autoplay } from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/autoplay';
import Alpine from 'alpinejs'
import collapse from '@alpinejs/collapse'
 
window.Alpine = Alpine
Alpine.plugin(collapse)
  
Alpine.start()

const menus = document.querySelectorAll("#menu-regios, #menu-vakgebieden");

menus.forEach(menu => {
    const items = menu.querySelectorAll("li.menu-item");
    const maxVisible = 5;

    if (items.length > maxVisible) {
        for (let i = maxVisible; i < items.length; i++) {
            items[i].style.display = "none";
        }

        const toggleBtn = document.createElement("li");
        toggleBtn.className = "menu-item toggle-more";
        toggleBtn.innerHTML = '<a href="#" class="read-more-widget" style="cursor:pointer;">Toon meer</a>';
        menu.appendChild(toggleBtn);

        let expanded = false;

        toggleBtn.addEventListener("click", function(e) {
            e.preventDefault();
            if (!expanded) {
                for (let i = maxVisible; i < items.length; i++) {
                    items[i].style.display = "block";
                }
                toggleBtn.querySelector("a").textContent = "Toon minder";
                expanded = true;
            } else {
                for (let i = maxVisible; i < items.length; i++) {
                    items[i].style.display = "none";
                }
                toggleBtn.querySelector("a").textContent = "Toon meer";
                expanded = false;
            }
        });
    }
});


// init Swiper:
const swiper = new Swiper('.news-swiper', {
    slidesPerView: 1,
    spaceBetween: 32,
    edgeSwipeDetection: true,
    watchSlidesProgress: true,
    breakpoints: {
        '@0.75': {
            slidesPerView: 2,
            spaceBetween: 32,
        },
        '@1.00': {
            slidesPerView: 2,
            spaceBetween: 32,
        },
        '@1.50': {
            slidesPerView: 3,
            spaceBetween: 32,
        },
    }
});

// init Swiper:
const partners = new Swiper('.partners', {
    modules: [Autoplay],
    slidesPerView: 2,
    spaceBetween: 32,
    edgeSwipeDetection: true,
    watchSlidesProgress: true,
    autoplay: {
        delay: 2500,
        disableOnInteraction: false,
    },
    breakpoints: {
        '@0.75': {
            slidesPerView: 2,
            spaceBetween: 32,
        },
        '@1.00': {
            slidesPerView: 4,
            spaceBetween: 32,
        },
        '@1.50': {
            slidesPerView: 5,
            spaceBetween: 32,
        },
    }
});



// Add class to body on scroll
jQuery(window).scroll(function () {
    var scroll = jQuery(window).scrollTop();
    if (scroll >= 500) {
        jQuery("body").addClass("scrolled");
    } else {
        jQuery("body").removeClass("scrolled");
        jQuery(".vacancy-bar").removeClass("upper");
    }
});

jQuery(window).scroll(function () {
    var scroll = jQuery(window).scrollTop();
    if (scroll >= 200) {
        jQuery("body").addClass("nav-scroll");
    } else {
        jQuery("body").removeClass("nav-scroll");
    }
});

// Vacancy detail, top bar
jQuery(window).scroll(function () {
    var scroll = jQuery(window).scrollTop();
    if (scroll >= 1200) {
        jQuery(".vacancy-bar").addClass("upper");
    }
});

// Mobile menu toggle
if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
    jQuery("body").on('click', '.hamburger-toggle', function () {
        jQuery('.hamburger-inner').toggleClass('is-collapsed');
        jQuery(this).toggleClass('menu-is-collapsed');
    });
} else {
    jQuery(".hamburger-toggle").mouseenter(function () {
        jQuery('.hamburger-inner').addClass('is-collapsed');
        jQuery(this).addClass('menu-is-collapsed');
        jQuery('body').addClass('menu-is-open');
    });
    jQuery(".hamburger-inner").mouseleave(function () {
        jQuery(this).removeClass('is-collapsed');
        jQuery('.hamburger-toggle').removeClass('menu-is-collapsed');
        jQuery('body').removeClass('menu-is-open');
    });
}

// filters
jQuery("body").on('click', '.filters', function () {
    jQuery('.filters').toggleClass('is-open');
});


// Replace search placeholders 
jQuery('input#inputQuery:text, .hero input#inputQuery:text').attr('placeholder', 'Zoek functie...');

jQuery('.review-item h4').each(function () {
    var me = jQuery(this);
    me.html(me.text().replace(/(^\w+)/, '<strong>$1</strong>'));
});

jQuery('.navigation ul:has( > li.current-menu-item)').addClass('has-active');


function readMore() {
    jQuery("body").on('click', '.readMore', function () {
        var id = jQuery(this).attr('ReadMore');
        jQuery('.' + id).slideToggle(300).addClass('active');

        if (jQuery(this).html() === "Lees meer") {
            jQuery(this).html('Lees minder');
            jQuery(this).toggleClass('open');
        } else {
            jQuery(this).html('Lees meer');
            jQuery(this).toggleClass('open');
        }
    });
}
readMore()
